export enum TranslationProvider {
    Unknown = 0,
    DeepL = 1,
    Google = 2
}